import { makeStyles, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import OrderDetailProgressBar from '../../Order/OrderDetailProgressBar';
import OrderDetailAssignment from '../../Order/OrderDetailAssignment';
import OrderDetailMaterials from '../../Order/OrderDetailMaterials';
import OrderDetailSideBar from '../../Order/OrderDetailSideBar';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import ManualReplenishmentDrawer from '../../ManualReplenishment/ManualReplenishmentDrawer';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { productionOrderStates } from '../../../Config/productionOrderStates'
import MaterialCorrectionDrawer from '../../ManualReplenishment/MateriaCorrectionDrawer';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';
import { connect } from 'react-redux';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import { closeFinishRushOrderDialogTimeout } from '../../../Config/constants';

export const OrderDetailPage = (props) => {
    const classes = useStyles();

    const [order, setOrder] = useState(null);
    const [nextOrder, setNextOrder] = useState(null);
    const [manualReplenishmentDrawerOpen, setManualReplenishmentDrawerOpen] = useState(false);
    const [orderRefresh, setOrderRefresh] = useState(false);
    const [editable, setEditable] = useState(false)
    const [rushOrder,setRushOrder] = useState(false)
    const [productionOrders, setProductionOrders] = useState([])
    const [finishRushOrderDialog, setFinishRushOrderDialogOpen] = useState(false)
    const [quantitiesAssigned, setQuantitiesAssigned] = useState([])
    const [quantityIdToRemove, setQuantityIdToRemove] = useState(null)
    const [materialCorrectionDrawerOpen, setMaterialCorrectionDrawerOpen] = useState(false);
    const [deleteQuantitiesDialogOpen, setDeleteQuantitiesDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [pdfReady, setPdfReady] = useState(false)

    const { t } = useTranslation();

    useEffect(() => {

        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(productionOrder => {
            if (JSON.stringify(productionOrder) !== JSON.stringify(order)) {
                setOrder(productionOrder)
                if (productionOrder.metaData) {
                    if (productionOrder.productionOrderStatus === productionOrderStates.PLANNED) {
                        console.log(productionOrder.metaData)
                        setEditable(JSON.parse(productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].RushOrder)
                    } else {
                        setEditable(false)
                    }            
                    setRushOrder(JSON.parse(productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].RushOrder)
                }
            }

            dataService.getMachineInAssignedByMachineId(productionOrder.machineIdPlanned).then(assigned => {

                if (JSON.stringify(assigned) !== JSON.stringify(quantitiesAssigned)) {
                    setQuantitiesAssigned(assigned)
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

            dataService.getProductionOrdersByMachine(1).then(orders => {
                setProductionOrders(orders)
                if (productionOrder.productionOrderStatus !== productionOrderStates.STOPPED && productionOrder.productionOrderStatus !== productionOrderStates.DONE) {
                    orders = orders.filter(x => x.productionOrderStatus !== productionOrderStates.STOPPED && x.productionOrderStatus !== productionOrderStates.DONE)
                }
                else {
                    orders = orders.filter(x => x.productionOrderStatus === productionOrderStates.STOPPED || x.productionOrderStatus === productionOrderStates.DONE)
                }

                let index = orders.sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).findIndex(x => x.id === productionOrder.id)
                if (index + 1 >= orders.length) {
                    setNextOrder(null)
                }
                else {
                    setNextOrder(orders[index + 1])
                }

                setPdfReady(true)

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }, [order, props.match.params.id, orderRefresh])

    useEffect(() => {
        
        if (props.order.refreshOrders) {
            console.log("orderRefresh")
            setOrderRefresh(!orderRefresh)
            props.actions.refreshOrders(false)
        }
    }, [props.order.refreshOrders])

    useEffect(() => {
        if (productionOrders.length > 0) {
            setOrderRefresh(!orderRefresh)
            var orderReferenceString = ""
            for (var orderId of props.order.finishedOrderIds) {
                var order = productionOrders.find(x => x.id === orderId)
                if (JSON.parse(order.metaData).find(x => x.MetaDataType === 1).MetaData[0].RushOrder) {
                    if (orderReferenceString === "") {
                        orderReferenceString += order.reference
                    }
                    else {
                        orderReferenceString += " & " + order.reference
                    }
                }
            }

            if (orderReferenceString !== "") {
                setDialogTitle("Order finished!")
                setDialogContext("Flashlight is ready for rush order(s): " + orderReferenceString)
                setFinishRushOrderDialogOpen(true)
                setTimeout(() => setFinishRushOrderDialogOpen(false), closeFinishRushOrderDialogTimeout)
            }
        }

    }, [props.order.finishedOrderIds])

    const openManualReplenishmentDrawer = (open) => {
        setManualReplenishmentDrawerOpen(open);
    }

    const openMaterialCorrectionDrawer = (open) => {
        setMaterialCorrectionDrawerOpen(open);
    }

    const refreshOrder = () => {
        setOrderRefresh(!orderRefresh)
    }

    const openDeleteQuantitiesDialog = (id) => {
        console.log('jajajaja')
        setQuantityIdToRemove(id)
        setDialogTitle("Delete")
        setDialogContext("Are you sure deleting this quantity?")
        setDeleteQuantitiesDialogOpen(true)
    }

    const getQuantityAtMachine = (productId) => {
        let quantityAtMachine = 0;
        var i;
        for (i = 0; i < quantitiesAssigned.length; i++) {

            if (JSON.parse(quantitiesAssigned[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].ProductId === productId) {
                quantityAtMachine += quantitiesAssigned[i].quantityAssigned
            }
        }

        return quantityAtMachine;
    }

    const deleteMaterialAssigned = (id) => {
        dataService.deleteMachineInAssignedById(id).then(
            setOrderRefresh(!orderRefresh)
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setDeleteQuantitiesDialogOpen(false)
    }

    function replenishMaterial(quantity, id) {
        dataService.assignQuantityAtMachine(order.machineIdPlanned, id, quantity).then(setOrderRefresh(!orderRefresh)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const closeFinishRushOrderDialog = () => {
        setFinishRushOrderDialogOpen(false)
    }

    let toComponent = null;
    if (nextOrder) {
        toComponent = `/order/${nextOrder.id}`;

    } else {
        if (order) {
            toComponent = `/order/${order.id}`
        }
    }

    return (
        <div className={classes.background}>
            {order ? <React.Fragment>
                <div className={classes.main}>
                    <div className={classes.header}>
                        <div className={classes.navButton}>
                            <NavLink className={classes.navButton} to={`/`}>
                                <BackForwardButton direction={'Back'} textOverride={"Back to production queue"}></BackForwardButton>
                            </NavLink>                        </div>
                        <div className={classes.orderNumber}>
                            {order.reference}
                        </div>
                    </div>
                    <div className={classes.body}>
                        <div className={classes.upperBody}>
                            <div className={classes.progress}>
                                <div className={classes.productionProgress}>
                                    {'Production progress (n° of pieces)'}
                                </div>
                                <OrderDetailProgressBar productionOrder={order} {...props}></OrderDetailProgressBar>
                            </div>
                            <div className={classes.upNext}>
                                <div className={classes.upNextHeader}>
                                    <div className={classes.titleUpNext}>
                                        {t('UpNext')}:
                                    </div>
                                    <NavLink className={classes.navButton} to={toComponent}>
                                        {nextOrder ? <div className={classes.viewDetailsButton}>
                                            <Button>
                                                <div className={classes.viewDetails}>
                                                    {t('ViewDetails')}
                                                </div>
                                                <ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon>
                                            </Button>
                                        </div>
                                            :
                                            <React.Fragment></React.Fragment>}
                                    </NavLink>
                                </div>
                                <div className={classes.timeNextOrder}>
                                    <div className={classes.timeSvg}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" className="__web-inspector-hide-shortcut__"><defs></defs><path className="a" fill="#8d8d8d" fillRule="evenodd" d="M2.2,2.2A7.224,7.224,0,0,1,7.5,0a7.224,7.224,0,0,1,5.3,2.2A7.224,7.224,0,0,1,15,7.5a7.224,7.224,0,0,1-2.2,5.3A7.224,7.224,0,0,1,7.5,15a7.224,7.224,0,0,1-5.3-2.2A7.224,7.224,0,0,1,0,7.5,7.224,7.224,0,0,1,2.2,2.2Zm5.97.479h-.8V7.366H4.018v.8H8.17Z" /></svg></div>
                                    <div className={classes.time}>
                                        {nextOrder ? nextOrder.reference : ''}
                                    </div>
                                </div>
                                <div className={classes.gradientSplitter}>
                                </div>
                                <div className={classes.nextOrderCode}>
                                    {nextOrder ? nextOrder.ordernumber : t('NoNextOrder')}
                                </div>
                            </div>
                        </div>

                        <div className={classes.middleBody}>
                            <OrderDetailAssignment productionOrder={order} setOrder={setOrder} editable={editable} {...props} refreshOrder={refreshOrder}></OrderDetailAssignment>
                        </div>

                        <div className={classes.lowerBody}>
                            <OrderDetailMaterials openMaterialCorrectionDrawer={openMaterialCorrectionDrawer} openManualReplenishmentDrawer={openManualReplenishmentDrawer} productionOrder={order} {...props} getQuantityAtMachine={getQuantityAtMachine}></OrderDetailMaterials>
                        </div>
                    </div>
                </div>
                <div className={classes.sideBar}>
                    <OrderDetailSideBar pdfReady={pdfReady} productionOrder={order} openReplenishmentDrawer={openManualReplenishmentDrawer} {...props} actions={props.actions} refreshOrder={refreshOrder} rushOrder={rushOrder}></OrderDetailSideBar>
                </div>
                <AlertDialog dialogOpen={finishRushOrderDialog} closeDialog={closeFinishRushOrderDialog} dialogContext={dialogContext} dialogTitle={dialogTitle} action={closeFinishRushOrderDialog}></AlertDialog>
                <MaterialCorrectionDrawer opendrawer={openMaterialCorrectionDrawer} draweropen={materialCorrectionDrawerOpen} quantitiesAssigned={quantitiesAssigned} productionOrder={order} openDeleteQuantitiesDialog={openDeleteQuantitiesDialog}></MaterialCorrectionDrawer>
                <DeleteDialog dialogOpen={deleteQuantitiesDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setDeleteQuantitiesDialogOpen(false)} action={() => deleteMaterialAssigned(quantityIdToRemove)}></DeleteDialog>
                <ManualReplenishmentDrawer opendrawer={openManualReplenishmentDrawer} draweropen={manualReplenishmentDrawerOpen} actions={props.actions} productionOrder={order} {...props} replenishmaterial={replenishMaterial}></ManualReplenishmentDrawer>
            </React.Fragment> : <React.Fragment></React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles({
    header: {
        height: '100px',
        marginTop: "20px"
    },
    body: {
        height: "100px"
    },
    orderNumber: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "5px"
    },
    background: {
        padding: "1.6%",
        paddingRight: "0px",
        paddingTop: "0px",
        position: "relative",
        top: "40px"

    },
    sideBar: {
        width: "20%",
        float: "left",
        background: "linear-gradient(white, transparent);",
        height: "95%"
    },
    main: {
        width: "80%",
        float: "left"
    },
    upperBody: {
        display: "block",
        height: "100px"
    },
    middleBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    lowerBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    progress: {
        height: "100px",
        width: "68%",
        backgroundColor: "white",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "10px"
    },
    upNext: {
        height: "100px",
        width: "29%",
        border: "1px solid #DEDEDE",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "10px"
    },
    productionProgress: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block",
        width: "100%",
        marginLeft: "3%",
        marginTop: "10px"

    },
    viewDetails: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        marginRight: "5px"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
    titleUpNext: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    viewDetailsButton: {
        float: "right"
    },
    upNextHeader: {
        display: 'block',
        height: "20px"
    },
    timeNextOrder: {
        display: 'block',
        height: "30px"
    },
    timeSvg: {
        float: "left",
        marginTop: "7px",
        marginRight: "5px"

    },
    time: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    gradientSplitter: {
        display: 'block',
        width: "100%",
        height: "7px",
        background: " transparent linear-gradient(90deg, #DEDEDE 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;",
        marginTop: "3px",
        borderRadius: "5px"
    },
    nextOrderCode: {
        display: 'block',
        fontSize: "13px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        marginTop: '3px'
    },
    navButton: {
        textDecoration: "none",
        border: "none",
        outline: "none",

    }
});

function mapStateToProps(state) {
    return {
        order: state.order
    }
}

export default connect(mapStateToProps)(OrderDetailPage)